import { render, staticRenderFns } from "./ProjectSelector.vue?vue&type=template&id=2106c80a"
import script from "./ProjectSelector.vue?vue&type=script&lang=js"
export * from "./ProjectSelector.vue?vue&type=script&lang=js"
import style0 from "./ProjectSelector.vue?vue&type=style&index=0&id=2106c80a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports